import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const FONTS = ["Roboto", "Open Sans", "Lato", "Montserrat", "Source Sans 3", "Nunito", "Poppins", "Inter Tight", "Arial", "Georgia"];
const COLORS = [
  ["primary", "Primærfarge (titler, skipsnavn)"], ["accent", "Aksentfarge (lenker, dato)"], ["background", "Bakgrunn"], ["card_bg", "Kort"],
  ["text", "Tekst"], ["muted", "Dempet tekst"], ["border", "Kantlinjer"], ["hover", "Hover på kort"],
  ["status_in", "Status: I havnen"], ["status_expected", "Status: Forventet"], ["status_departed", "Status: Avgått"], ["status_cancelled", "Status: Kansellert"],
];
const SIZES = [["heading_size", "Overskrift", 12, 40], ["name_size", "Skipsnavn", 12, 32], ["font_size", "Brødtekst", 11, 22],
  ["padding", "Luft rundt", 8, 40], ["gap", "Avstand mellom kort", 4, 40], ["radius", "Hjørneradius", 0, 24]];

const Box = ({ title, children }) => (
  <div className="bg-white border border-slate-200 rounded-lg p-4 sm:p-5 space-y-4">
    <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
    {children}
  </div>
);

const Text = ({ label, value, onChange, testId, ph, max = 400 }) => (
  <label className="space-y-1.5 block">
    <span className="text-xs font-medium text-slate-600">{label}</span>
    <Input value={value} maxLength={max} placeholder={ph} onChange={(e) => onChange(e.target.value)} data-testid={testId} />
  </label>
);

const Color = ({ k, label, value, onChange }) => (
  <label className="flex items-center gap-3 min-w-0">
    <input type="color" value={value} onChange={(e) => onChange(e.target.value)} className="w-9 h-9 shrink-0 rounded border border-slate-200 bg-white p-0.5 cursor-pointer" data-testid={`teaser-color-${k}`} />
    <span className="min-w-0">
      <span className="block text-xs text-slate-700 truncate">{label}</span>
      <span className="block text-[11px] text-slate-400 font-num uppercase">{value}</span>
    </span>
  </label>
);

export const TeaserSettings = ({ t, onChange }) => (
  <div className="grid lg:grid-cols-2 gap-4" data-testid="teaser-settings">
    <Box title="Tekster og logo">
      <Text label="Overskrift" value={t.heading} max={80} onChange={(v) => onChange({ heading: v })} testId="teaser-heading" ph="Neste anløp" />
      <Text label="Tekst over widgeten" value={t.text_above} onChange={(v) => onChange({ text_above: v })} testId="teaser-text-above" />
      <Text label="Tekst under widgeten" value={t.text_below} onChange={(v) => onChange({ text_below: v })} testId="teaser-text-below" />
      <Text label="Lenke til hele anløpslisten (valgfritt)" value={t.list_url} max={500} onChange={(v) => onChange({ list_url: v.trim() }, 1200)} testId="teaser-list-url" ph="https://dinhavn.no/anlopsliste" />
      <label className="flex items-center justify-between gap-3 rounded-md border border-slate-200 px-3 py-2.5">
        <span className="text-sm text-slate-700">Vis logoen ved overskriften</span>
        <Switch checked={t.show_logo} onCheckedChange={(v) => onChange({ show_logo: v }, 0)} data-testid="teaser-show-logo" />
      </label>
    </Box>
    <Box title="Fonter og størrelser">
      <label className="space-y-1.5 block">
        <span className="text-xs font-medium text-slate-600">Font</span>
        <Select value={t.font_family} onValueChange={(v) => onChange({ font_family: v }, 0)}>
          <SelectTrigger data-testid="teaser-font"><SelectValue /></SelectTrigger>
          <SelectContent>{FONTS.map((f) => <SelectItem key={f} value={f}>{f}</SelectItem>)}</SelectContent>
        </Select>
      </label>
      <div className="grid sm:grid-cols-2 gap-x-5 gap-y-3">
        {SIZES.map(([k, l, min, max]) => (
          <label key={k} className="block space-y-1">
            <span className="flex justify-between text-xs text-slate-600"><span>{l}</span><span className="font-num text-slate-900">{t[k]} px</span></span>
            <input type="range" min={min} max={max} value={t[k]} onChange={(e) => onChange({ [k]: Number(e.target.value) })} className="w-full accent-sky-700" data-testid={`teaser-size-${k}`} />
          </label>
        ))}
      </div>
    </Box>
    <div className="lg:col-span-2">
      <Box title="Farger">
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
          {COLORS.map(([k, l]) => <Color key={k} k={k} label={l} value={t[k]} onChange={(v) => onChange({ [k]: v.toUpperCase() })} />)}
        </div>
        <p className="text-xs text-slate-500">Statusfargene brukes også i den fulle anløpslisten. Den fulle listen bruker ellers fonten og fargene fra kalkulatoren.</p>
      </Box>
    </div>
  </div>
);
